// extracted by mini-css-extract-plugin
export var button = "style-module--button--1Tflh";
export var first = "style-module--first--xuZ26";
export var root = "style-module--root--AHpoN";
export var second = "style-module--second--v-hV9";